export type ApiErrorBody = {
    code?: string;
    message?: string;
    details?: unknown;
};

export class ApiError extends Error {
    readonly status: number;
    readonly body: ApiErrorBody | null;

    constructor(status: number, message: string, body: ApiErrorBody | null) {
        super(message);
        this.name = 'ApiError';
        this.status = status;
        this.body = body;
    }
}
